/* eslint-disable no-param-reassign */
import { useEffect, useState } from 'react';
import { CircleError, CircleSuccess } from '../../../juristec-ui/icons';
import { ResponseContainer, ResponseItem } from './styled/TransferKpi.styled';

interface ResponseDash {
  error: boolean;
  msg: string;
  dashId: string;
  raw?: string;
}

interface ResponseFile {
  id: string;
  msg: string;
}

interface ResponseList {
  updatedDashs: ResponseDash[];
  errorDashs: ResponseDash[];
  errorFiles: ResponseFile[];
  dashboards: Record<string, string>[];
  fileList: Record<string, string>[];
}

const ResponseList = ({
  updatedDashs,
  errorDashs,
  errorFiles,
  dashboards,
  fileList,
}: ResponseList) => {
  const [dashNameMap, setDashNameMap] = useState<Record<string, string>>({});
  const [fileNameMap, setFileNameMap] = useState<Record<string, string>>({});

  useEffect(() => {
    setDashNameMap(
      dashboards.reduce((aux, d) => {
        aux[d.id] = d.name;
        return aux;
      }, {}),
    );
    setFileNameMap(
      fileList.reduce((aux, f) => {
        aux[f.file_id] = f.filename;
        return aux;
      }, {}),
    );
  }, [dashboards?.length, fileList?.length]);

  return (
    <ResponseContainer>
      {updatedDashs.map((d) => (
        <ResponseItem key={d.dashId} className="success">
          <CircleSuccess />
          <span>
            <b>
              {`Dashboard ${dashNameMap[d.dashId]}`}
            </b>
            {" - KPI's transferidos com sucesso!"}
          </span>
        </ResponseItem>
      ))}
      {errorDashs.map((ed) => (
        <ResponseItem key={ed.dashId} className="error">
          <CircleError />
          <span>
            <b>
              {`Dashboard ${dashNameMap[ed.dashId]}`}
            </b>
            {` - ${ed.msg}: ${ed.raw}`}
          </span>
        </ResponseItem>
      ))}
      {errorFiles.map((ef) => (
        <ResponseItem key={ef.id} className="error">
          <CircleError />
          <span>
            <b>
              {`Arquivo ${fileNameMap[ef.id]}`}
            </b>
            {` - ${ef.msg}`}
          </span>
        </ResponseItem>
      ))}
    </ResponseContainer>
  );
};

export default ResponseList;
